import type { User } from './auth-client';

/**
 * How many active saved searches this reader may keep: `Infinity` when
 * unlimited, otherwise the cap the API reports.
 *
 * The number is NOT duplicated here — `GET /auth/me` sends `savedSearchLimit`
 * from the same rule `POST /me/saved-searches` enforces. Two fallbacks:
 *  - `subscription.unlimitedSavedSearches === true` wins even if the field is
 *    missing (older payloads carried only that flag);
 *  - an ABSENT `savedSearchLimit` reads as 1 — a payload without the field
 *    comes from an API that still enforces the old one-search cap, and
 *    offering «create new» there would end in a 403.
 */
export function savedSearchCapFor(user: User | null | undefined): number {
  if (user?.subscription?.unlimitedSavedSearches === true) return Infinity;
  const limit = user?.savedSearchLimit;
  if (limit === null) return Infinity;
  return typeof limit === 'number' && limit > 0 ? limit : 1;
}
